import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'filter.location.title',
    defaultMessage: 'Lieux des cours',
  },
  indifferent: {
    id: 'filter.location.indifferent',
    defaultMessage: 'Indifférent ✨',
  },
  online: {
    id: 'filter.location.online',
    defaultMessage: 'En ligne 🖥️',
  },
  atHome: {
    id: 'filter.location.atHome',
    defaultMessage: 'À domicile 🏡',
  },
});
